// extracted by mini-css-extract-plugin
export default {"contentPage":"contentPage_contentPage__h-XWc"};